export function HomeWorkIcon(): JSX.Element {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8335 5.83333H14.1668V7.5H15.8335V5.83333Z"
        fill="currentColor"
      />
      <path
        d="M15.8335 9.16667H14.1668V10.8333H15.8335V9.16667Z"
        fill="currentColor"
      />
      <path
        d="M15.8335 12.5H14.1668V14.1667H15.8335V12.5Z"
        fill="currentColor"
      />
      <path
        d="M0.833496 9.16667V17.5H5.8335V13.3333H7.50016V17.5H12.5002V9.16667L6.66683 5L0.833496 9.16667ZM10.8335 15.8333H9.16683V11.6667H4.16683V15.8333H2.50016V10L6.66683 7.08333L10.8335 10V15.8333Z"
        fill="currentColor"
      />
      <path
        d="M8.3335 2.5V4.14167L10.0002 5.33333V4.16667H17.5002V15.8333H14.1668V17.5H19.1668V2.5H8.3335Z"
        fill="currentColor"
      />
    </svg>
  );
}
